import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Navigation } from "@/components/Navigation";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ScrollToTopButton } from "@/components/ScrollToTopButton";
import { CookieConsent } from "@/components/CookieConsent";
import { CustomCursor } from "@/components/CustomCursor";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CV from "./pages/CV";
import ProjectDetail from "./pages/ProjectDetail";
import PortfolioReview from "./pages/PortfolioReview";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const AppRoutes = () => {
  const { pathname } = useLocation();
  const isPortfolioReview = pathname === "/portfolio-review";

  return (
    <>
      {!isPortfolioReview && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio-review" element={<PortfolioReview />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <CustomCursor />
          <ScrollToTop />
          <ScrollToTopButton />
          <CookieConsent />
          <AppRoutes />
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
    </QueryClientProvider>
  );
};

export default App;
